const menu = [
  // {
  //   heading: "Dashboard",
  // },
  // {
  //   icon: "growth-fill",
  //   text: "Dashboard",
  //   link: "/dashBoard",
  // },
  {
    icon: "tile-thumb-fill",
    text: "Tenant",
    active: false,
    subMenu: [
      {
        text: "Manage Tenant",
        link: "/Tenant/Accounts/manage-tenant",
      },
    ],
  },
  {
    icon: "users-fill",
    text: "Users",
    active: false,
    subMenu: [
      {
        text: "Manage Users",
        link: "/manage-users",
      },
    ],
  },

  // {
  //   icon: "cc-alt2-fill",
  //   text: "Rights",
  //   active: false,
  //   subMenu: [
  //     {
  //       text: "Rights Management",
  //       link: "/order-list-default",
  //     },
  //   ],
  // },
  // {
  //   icon: "file-docs",
  //   text: "Invoice",
  //   active: false,
  //   subMenu: [
  //     {
  //       text: "Generate Invoice",
  //       link: "/invoice-details/1",
  //     },
  //   ],
  // },
  // {
  //   icon: "file-docs",
  //   text: "Usage",
  //   active: false,
  //   subMenu: [
  //     {
  //       text: "Check Usage",
  //       link: "/kyc-list-regular",
  //     },
  //   ],
  // },
  // {
  //   icon: "grid-alt-fill",
  //   text: "Reports",
  //   active: false,
  //   subMenu: [
  //     {
  //       text: "Usage Report",
  //       link: "/app-messages",
  //     },
  //     {
  //       text: "Billing Report",
  //       link: "/app-chat",
  //     },
  //   ],
  // },
];
export default menu;
